module.exports = __webpack_public_path__ + "img/8e2691d4897c02207eea570a0ef0d2de.215fb38e.jpg";